var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcButton',{staticClass:"appointment-slot",attrs:{"wide":true},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._v("\n\t"+_vm._s(_vm.startTime)+" - "+_vm._s(_vm.endTime)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }